const localstorageAPIExists = function (storageName) {
    if (!storageName) return;
    const prefix = storageName.substring(0, 9);
    if (prefix === 'livechat_') {
        storageName = storageName.substring(prefix.length, storageName.length);
        return (
            ApexChat.localStorageAPI.Exists(`apexchat_${storageName}`) ||
            ApexChat.localStorageAPI.Exists(`livechat_${storageName}`)
        );
    }
    return ApexChat.localStorageAPI.Exists(storageName);
};
export default localstorageAPIExists;
